import appConfig from '$app/internal/main';
import render from '$app/render/client';

/**
 * Client entry point to create the client bundle
 */

// onclick = () => {
//   render(appConfig.createApp, import.meta.env.APP_NAME);
// };

render(appConfig.createApp, import.meta.env.APP_NAME);
